import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./components/root/Home";
import PageHeader from "./components/root/Header";
import About from "./components/root/About";
import Posts from "./components/posts/Posts";
import SinglePost from "./components/posts/SinglePost";
import { Layout, ConfigProvider } from "antd";
import PageFooter from "./components/root/Footer";
import Gallery from "./components/gallery/Gallery";
import { Content } from "antd/es/layout/layout";
import usePageTracking from "./custom-hooks/usePageTracking";

export default function App() {
  usePageTracking();
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#f3c4c0",
          colorBgBase: "#f9f7f4",
          colorText: "#333",
          fontFamily: "'Amiri', serif",
        },
      }}
    >
      <Layout>
        <PageHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/claire" element={<Posts />} />
          <Route path="/charlie" element={<Posts />} />
          <Route path="/post/:id" element={<SinglePost />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Content />} />
        </Routes>
        <PageFooter />
      </Layout>
    </ConfigProvider>
  );
}
